import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { HolidayAndWayOfWorkingListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialHolidayAndWayOfWorkingList } from '../../logics/holidayAndWayOfWorking/createInitialHolidayAndWayOfWorkingList';

/**
 * 休日・働き方に関するhooks
 * @param args
 * @returns 表示配列と更新処理
 */
export const useHolidayAndWayOfWorking = (args: HooksArgument) => {
  const [holidayAndWayOfWorkingList, setHolidayAndWayOfWorking] = useState<
    HolidayAndWayOfWorkingListType[]
  >(createInitialHolidayAndWayOfWorkingList(args));

  const selectedHolidayAndWayOfWorkingList = useMemo(() => {
    return holidayAndWayOfWorkingList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [holidayAndWayOfWorkingList]);

  // チェック状態更新処理
  const updateIsCheckedHolidayAndWayOfWorkingList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = holidayAndWayOfWorkingList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setHolidayAndWayOfWorking(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [holidayAndWayOfWorkingList]
  );

  // 求人件数更新処理
  const updateHolidayAndWayOfWorkingListJobCount = useCallback(
    (
      holidayAndWayOfWorkingJobCountList: JobCountDetailResponse[] | undefined
    ) => {
      setHolidayAndWayOfWorking((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(
            holidayAndWayOfWorkingJobCountList,
            item.value
          ),
        }))
      );
    },
    []
  );

  return {
    holidayAndWayOfWorkingList,
    selectedHolidayAndWayOfWorkingList,
    updateIsCheckedHolidayAndWayOfWorkingList,
    updateHolidayAndWayOfWorkingListJobCount,
  };
};
